import React from 'react';
import { CTAButton } from './CTAButton';
export function ClosingSection() {
  return <section className="py-10 px-4 bg-gradient-to-b from-purple-50/30 to-amber-50/40 text-center" data-id="element-61">
      <div className="max-w-2xl mx-auto" data-id="element-62">
        <h2 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-63">
          🌱 No se trata de hacer más
          <br data-id="element-64" />
          <span className="text-green-600" data-id="element-65">Se trata de estar mejor</span>
        </h2>

        <p className="text-xl text-gray-700 mb-4" data-id="element-66">
          Tus hijos no van a recordar todos los días. Van a recordar cómo se
          sintieron con vos.
          <br data-id="element-67" />
          <br data-id="element-68" />
          <span className="font-bold" data-id="element-69">Y eso… lo estás construyendo hoy.</span>
        </p>

        <div className="bg-yellow-50 p-5 rounded-xl border border-yellow-200 mb-6" data-id="element-70">
          <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-71">
            💛 CREANDO RECUERDOS REALES
          </h3>
          <p className="text-lg text-gray-600" data-id="element-72">
            Un pack para hoy. Un regalo para toda la vida.
          </p>
        </div>

        <CTAButton text="👉 Accedé ahora antes de que termine la oferta" subtext="Descarga inmediata" data-id="element-73" />
      </div>
    </section>;
}